import { Component, OnInit, OnDestroy } from '@angular/core';
import { Meta } from '@angular/platform-browser';

import { environment } from '../environments/environment';

// i18n support
import { TranslateService } from '@ngx-translate/core';
import { RoutingStateService } from './services/routing-state.service';
import { AuthService } from '../../../admin/src/app/services/auth.service';
import { UserService } from '../../../admin/src/app/services/user.service';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { LanguageService } from './services/language.service';
import { NgcCookieConsentService } from 'ngx-cookieconsent';
import { MatomoTracker } from 'ngx-matomo';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'app';

  version: string = environment.version;

  apiVersion: string = environment.apiVersion;

  sub: Subscription;

  privacyUrl = "https://www.elite-it.com/en/privacy-policy";

  constructor(
    private routingState: RoutingStateService,
    private authSvc: AuthService,
    private userSvc: UserService,
    public translate: TranslateService,
    private meta: Meta,
    public router: Router,
    private route: ActivatedRoute,
    private language: LanguageService,
    private ccService: NgcCookieConsentService,
    private matomoTracker: MatomoTracker
  ) {
    this.routingState.trackRouting();

    let lang = navigator.language.substr(0, 2);
    this.language.setLang(lang);

    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang('en');

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    // translate.use(lang);

    let firstNavigationEnd = true;

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.matomoTracker.setCustomUrl(event.url);
        const count = event.url.split('/').length;
        this.routingState.setShowHeaderLogo(count > 2);
        if (/*environment.production && */this.ccService.hasConsented()) {
          this.matomoTracker.setDoNotTrack(false);
        } else {
          this.matomoTracker.setDoNotTrack(true);
        }
        if (firstNavigationEnd) {
          firstNavigationEnd = false;
          if (event.url === '/') {
            translate.use(lang);
            this.language.setLang(lang);
            this.updateCookieBanner(lang);
            if (lang === 'it') {
              this.privacyUrl = "https://www.elite-it.com/it/privacy-policy";
            } else {
              this.privacyUrl = "https://www.elite-it.com/en/privacy-policy";
            }
          } else {
            const pathLang = event.url.substring(1, 3);
            translate.use(pathLang);
            this.language.setLang(pathLang);
            this.updateCookieBanner(pathLang);
            if (pathLang === 'it') {
              this.privacyUrl = "https://www.elite-it.com/it/privacy-policy";
            } else {
              this.privacyUrl = "https://www.elite-it.com/en/privacy-policy";
            }
          }
        }
      }
    });

    this.updateCookieBanner('en');
  }

  ngOnInit() {
    this.verifyAccessToken();
    this.meta.addTag({ name: 'version', content: this.version });
    this.meta.addTag({ name: 'api-version', content: this.apiVersion });

    this.sub = this.route.paramMap.subscribe(params => {
      const language = params.get('language');
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  verifyAccessToken() {
    if (!!this.authSvc.getCurrentToken()) {
      let expiresOn: number = this.authSvc.getCurrentTokenExpiration();

      if (expiresOn < new Date().getTime()) {
        this.authSvc.invalidateCurrentToken();
      } else {
        this.userSvc.getCurrentUser().subscribe(() => {});
      }
    }
  }

  private updateCookieBanner(lang: string) {
    this.translate
      .get(['cookie.header', 'cookie.message', 'cookie.dismiss', 'cookie.allow', 'cookie.deny', 'cookie.link', 'cookie.policy'])
      .subscribe(data => {
        this.ccService.getConfig().content = this.ccService.getConfig().content || {} ;
        // Override default messages with the translated ones
        this.ccService.getConfig().content.header = data['cookie.header'];
        this.ccService.getConfig().content.message = data['cookie.message'];
        this.ccService.getConfig().content.dismiss = data['cookie.dismiss'];
        this.ccService.getConfig().content.allow = data['cookie.allow'];
        this.ccService.getConfig().content.deny = data['cookie.deny'];
        this.ccService.getConfig().content.link = data['cookie.link'];
        this.ccService.getConfig().content.policy = data['cookie.policy'];
        if (lang === 'it') {
          this.ccService.getConfig().content.href = 'https://www.elite-it.com/it/privacy-policy';
        } else {
          this.ccService.getConfig().content.href = 'https://www.elite-it.com/en/privacy-policy';
        }

        this.ccService.destroy(); // remove previous cookie bar (with default messages)
        this.ccService.init(this.ccService.getConfig()); // update config with translated messages
      });
  }

}
